type SectionHeaderProps = {
  title: string;
};

export default function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <div className="relative mb-4 flex h-[50px] w-full items-center justify-center overflow-hidden">
      <img
        src="/shapes/Rectangle-grey-black-shape.svg"
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />
      <h2 className="daily-reveal-heading relative z-10 text-center text-[14px] uppercase tracking-[0.42px]">
        {title}
      </h2>
    </div>
  );
}
